function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "hellosign-a",
  points: "0 0 20 0 30 9.75 30 40 0 40"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "hellosign-b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#hellosign-a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#E3E7F4",
  fillRule: "nonzero",
  xlinkHref: "#hellosign-a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B3E6",
  d: "M8.76923077,29.6153846 L8.76923077,26.8461538 L21.2307692,26.8461538 L21.2307692,29.6153846 L8.76923077,29.6153846 Z M18.5838462,15.7692308 L11.415,15.7692308 L15,20.7307692 L18.5838462,15.7692308 M24,13 L15,25.4615385 L6,13 L24,13 Z",
  mask: "url(#hellosign-b)"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#CFD4E5",
  fillRule: "nonzero",
  points: "20 0 30 0 30 10 20 10",
  mask: "url(#hellosign-b)"
}));

var SvgHellosign = function SvgHellosign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHellosign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hellosign.1db122fc.svg";
export { ForwardRef as ReactComponent };